<template>
  <div class="coloring-wrapper">
    <div class="coloring-container">
      <!-- <div class="text-container"> </div> -->
      <tr-ui-title
        v-for="(title, index) in [coloring.coloringObj]"
        :key="coloring.id + '_' + index"
        class="free-position"
        :style="getCustomStyle(coloring.coloringObj)"
        :title-text="title.text"
        :audio="title.audio"
        :pos="title.pos"
        :width="730"
        :height="145"
      ></tr-ui-title>
      <div class="image-container">
        <div v-for="(game, index) in coloring.coloringObj.items" :key="'img_' + index" class="image-element">
          <img
            @mouseover="hover = true"
            @mouseleave="hover = false"
            @click="coloringLuncher(game.name)"
            :src="getImageSrc(game.path)"
            height="135"
            class="image-link"
          />
        </div>
        <!-- <div
          class="image-element"
          title="Aby rozpocząć, kliknij w przycisk."
          @click="coloringLuncher(coloring.coloringObj.items)"
        >
          <img draggable="false" :src="imagePath(coloring.icon)" class="icon-off" />
          <img draggable="false" :src="imagePath(coloring.icon, false)" class="icon-on" />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import TrUiTitle from '__mainSrcDir/components/TrGame/v4/UI/TrUiTitle/TrUiTitle';
export default {
  name: 'tr-coloring',
  components: {
    TrUiTitle,
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    showGame(gameObj) {
      // this.showModalGame = true;
      if (gameObj && _.isObject(gameObj.item) && _.isObject(gameObj.item.gameConfig)) {
        this.$store.commit('CHANGE_GAME_TYPE', 'singleStage');
        this.$store.commit('CHANGE_GAME_ACTIVE', true);
        this.$store.dispatch('setGameObject', gameObj);
        this.$store.dispatch('newGame', gameObj);
        // this.$router.push(`/game/${gameObj.id}`);
      } else if (
        gameObj &&
        _.isArray(gameObj.items) &&
        gameObj.items.reduce((acc, obj) => {
          return acc && obj.item && !_.isEmpty(obj.item.gameConfig);
        }, true)
      ) {
        /**
         * Multi Stage game
         */
        this.$store.commit('CHANGE_GAME_TYPE', 'multiStage');
        this.$store.dispatch('setGameObject', gameObj);
        if (gameObj.multiStageShuffle && gameObj.multiStagePick != 0) {
          this.$store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
          this.$store.commit('SET_GAME_OBJ_ITEMS', gameObj.items);
          this.$store.commit('PICK_GAMEOBJECT', gameObj.multiStagePick);
        } else if (gameObj.multiStageShuffle) {
          this.$store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
          this.$store.commit('SHUFFLE_GAMEOBJECT', _.shuffle(this.$store.getters.gameObj.items));
        }
        this.$store.commit('CHANGE_GAME_ACTIVE', true);
        this.$store.dispatch('newGame', this.$store.getters.gameObj);
      } else {
        console.error('NIE MOZNA ODNALEZC GRY O PODANYCH PARAMETRACH', gameObj);
      }
    },
    openFile(game) {
      console.log('JESTEM W 2 MIEJSCU');
      this.$router.push(`/game/${game}`);
    },
    coloringLuncher(link) {
      console.log('co jest w link?', link);
      if (link) {
        this.openFile(link);
        return true;
      }
      return false;
    },
    imagePath(iconId, off = true) {
      iconId = 'ikonaPaint';
      let images = require.context('../../../assets/icons/book/paintIcons/', false, /\.jpg$/);
      return images('./' + iconId + '.jpg');
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    coloring() {
      return this.$store.getters.coloringData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.coloring-container {
  width: 850px;
  height: 350px;
  z-index: 999;
  background-color: #fff;
  position: absolute;
  top: 250px;
  left: 460px;
  text-align: left;
  .image-container {
    display: flex;
    position: relative;
    pointer-events: auto;
    justify-content: space-around;
    top: 180px;
    // left: 15px;
    .image-element {
      max-width: min-content;
      margin-right: 7px;
      .image-link {
        transition: 0.6s all ease-in;
        border: 3px solid #e6e6e6;
        cursor: default;
      }
      .image-link:hover {
        transition: 0.3s all ease-in;
        box-shadow: 0px 0px 10px 2px $borderColor;
        border: 3px solid $borderColor;
        cursor: pointer;
      }
    }
  }
  .free-position {
    position: absolute;
    pointer-events: auto;
    z-index: 1006;
  }
}
</style>
